import { render, staticRenderFns } from "./EditStudentCapacity.vue?vue&type=template&id=6b433878"
import script from "./EditStudentCapacity.vue?vue&type=script&lang=js"
export * from "./EditStudentCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports